"use strict";

exports.__esModule = true;
exports.DeviceStatusOverlayController = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _DeviceStatus = require("../DeviceStatus");
var _DeviceLag = require("../DeviceLag");
var _DeviceStatusOverlay = require("./DeviceStatusOverlay");
var _class, _DeviceStatusOverlayController;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DeviceStatusOverlayController = exports.DeviceStatusOverlayController = (0, _styledComponents.withTheme)(_class = (_DeviceStatusOverlayController = /*#__PURE__*/function (_Component) {
  function DeviceStatusOverlayController() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DeviceStatusOverlayController, _Component);
  var _proto = DeviceStatusOverlayController.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      device = _this$props.device,
      iconSize = _this$props.iconSize;
    if (!device.hasRealtimeData) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_DeviceStatus.DeviceConnectionStatusContext.Provider, {
      device: device
    }, /*#__PURE__*/_react["default"].createElement(_DeviceStatus.DeviceConnectionStatusContext.Consumer, null, function (_ref) {
      var isDisconnected = _ref.isDisconnected;
      return /*#__PURE__*/_react["default"].createElement(_DeviceLag.DeviceLagContext.Provider, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_DeviceLag.DeviceLagContext.Consumer, null, function (_ref2) {
        var isLagging = _ref2.isLagging;
        return /*#__PURE__*/_react["default"].createElement(_DeviceStatusOverlay.DeviceStatusOverlay, {
          isDisconnected: isDisconnected,
          isLagging: isLagging,
          iconSize: iconSize
        });
      }));
    }));
  };
  return DeviceStatusOverlayController;
}(_react.Component), _DeviceStatusOverlayController.defaultProps = {
  iconSize: 48
}, _DeviceStatusOverlayController)) || _class;